export default __webpack_public_path__ + "5bdca4d6d42eff09495b11893cf380d1.svg";